/* tslint:disable */
import {
  Project
} from '../index';

declare var Object: any;
export interface ImageInterface {
  "url"?: string;
  "description"?: string;
  "projectId"?: number;
  "id"?: number;
  project?: Project;
}

export class Image implements ImageInterface {
  "url": string;
  "description": string;
  "projectId": number;
  "id": number;
  project: Project;
  constructor(data?: ImageInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Image`.
   */
  public static getModelName() {
    return "Image";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Image for dynamic purposes.
  **/
  public static factory(data: ImageInterface): Image{
    return new Image(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Image',
      plural: 'Images',
      path: 'Images',
      properties: {
        "url": {
          name: 'url',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "projectId": {
          name: 'projectId',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        project: {
          name: 'project',
          type: 'Project',
          model: 'Project'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/Image.ts